import React, { Suspense } from "react";
import Spinner from "../../../../views/spinner/Spinner";
import PreloaderCustom from "../../../../components/shared/PreloaderCustom";

const Loadable = (Component) => (props) =>
  (
    // <Suspense fallback={<Spinner />}>
    <Suspense fallback={<PreloaderCustom fullPreloader={props} />}>
      <Component {...props} />
    </Suspense>
  );

export default Loadable;
